<template>
  <div class="collections clearfix">
    <ul class="text-center clearfix w-full collection-tab-title">
      <li
        v-for="item in tabList"
        :key="item"
        :class="
          tab === item
            ? 'collection-tab-option active w-1/2 cursor-pointer float-left text-center'
            : 'collection-tab-option w-1/2 cursor-pointer float-left text-center'
        "
        @click="tabFn(item)"
      >
        {{ item }} <span class="line-vertical"></span>
      </li>
    </ul>
    <div v-if="tab === '珍品收藏'" class="w-full collection-li">
      <ceramicsContent type="collection" :pageSize="4"></ceramicsContent>
    </div>
    <div v-else class="w-full collection-li">
      <ArticleCollections></ArticleCollections>
    </div>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import valid from '@/core/mixins/valid'
import ceramicsContent from '@/components/ceramics/CeramicsContent'
import ArticleCollections from '../articleCollections/Index'

export default {
  name: 'collections',
  mixins: [link, valid],
  components: { ceramicsContent, ArticleCollections },
  data() {
    return {
      tab: '珍品收藏', // 一进页面显示第一个'历史概况'
      tabList: ['珍品收藏', '文章收藏']
    }
  },
  computed: {},
  watch: {},
  mounted: function() {},
  methods: {
    // tab栏切换
    tabFn(value) {
      this.tab = value
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.collections {
  height: 558px;
  background-color: $c-tour-bg-yellow;
  background-image: url('../../../../static/images/tour/bg-flower-y.png');
  background-repeat: no-repeat;
  background-size: auto 600px;
  background-position: 50% -10px;
  // margin-bottom: 160px;
  .collection-tab-title {
    height: 26px;
    line-height: 26px;
    margin: 47px 0;
    padding: 0 240px;
  }
  .collection-tab-option {
    font-size: 24px;
    color: $c-white;

    background-position: center;
    background-size: auto 0;
    background-repeat: no-repeat;
    background: url('../../../../static/images/public/left-big.png') 28% center
        no-repeat,
      url('../../../../static/images/public/right-big.png') 72% center no-repeat;
    background-size: auto 100%, auto 100%;

    &:hover {
      transition: all 0.35s;
      color: $c-tour-2;
    }

    &.active {
      transition: all 0.35s;
      color: $c-tour-2;
      background: url('../../../../static/images/public/left-deep-active.png')
          28% center no-repeat,
        url('../../../../static/images/public/right-deep-active.png') 72% center
          no-repeat;
      background-size: auto 100%, auto 100%;
    }
  }
  .collection-li {
    padding: 0 60px;
    height: 438px;
    .lists {
      position: static;
      overflow-y: visible;
    }
  }
  ::v-deep  .pag {
    position: absolute;
    padding: 0;
    left: 0;
    right: 0;
    bottom: 80px;
  }
}
</style>
